"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fixTextInColorbox = fixTextInColorbox;
function fixTextInColorbox(tex) {
    return tex.replace(/(\\colorbox\{[^}]*}\{)\\text /g, "$1");
}
